import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../../components/container/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../../components/notification/NotificationContainer";
import { useForm } from "react-hook-form";
import {
  addProposalPhase,
  getProject,
  unsetSelectedProject,
} from "../../../features/projectsSlice";
import PageTitle from "../../../components/titles/PageTitle";
import { useEffect, useLayoutEffect, useState } from "react";
import TextContainer from "../../../components/text/TextContainer";
import Loading from "../../../components/loading/Loading";
import LinkTextContainer from "../../../components/text/LinkTextContainer";
import DisplayComments from "../../../components/text/DisplayComments";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const PhaseTwoBegin = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);
  const projectBkg = useSelector(
    (state) => state.projects.load.addProposalPhase
  );

  const addNotification = useNotification();
  const { reset, handleSubmit } = useForm();

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      const res = await dispatch(addProposalPhase(data));
      if (addProposalPhase.fulfilled.match(res)) {
        addNotification("Successfully saved!", "success");
        return navigate("/proposals/basics/" + id);
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useLayoutEffect(() => {
    reset({ id: id });
    if (id) dispatch(getProject(id));

    return () => {
      dispatch(unsetSelectedProject());
    };
  }, []);

  useEffect(() => {}, [project]);

  if (projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer className="!px-2">
      {project.id && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mx-auto max-w-5xl">
            <PageTitle title="Planning - Proposal" />
          </div>
          <div className="mx-auto max-w-5xl w-full bg-content shadow-md px-3 sm:px-6 py-6 flex flex-col gap-0.5">
            <h5 className="summary-p text-lg mb-4">{project.name}</h5>
            <TextContainer
              label="Name of Applicant"
              content={`${project.creator.first_name} ${project.creator.last_name}`}
            />
            <TextContainer label="Community Name" content={project.community} />
            <TextContainer
              label="Address 1"
              content={project.community_address1}
            />
            <TextContainer
              label="Address 1"
              content={project.community_address2}
            />
            <TextContainer label="Province" content={project.province} />
            <TextContainer
              label="Project Location"
              content={project.project_location}
            />
            <TextContainer label="Email" content={project.creator.email} />
            <TextContainer label="Contact" content={project.creator.phone} />

            {/* Comments */}
            <DisplayComments comments={project.comments} />

            {/* Details */}
            <TextContainer label="Analysis" content={project.analysis} isHTML />
            <TextContainer
              label="Problem Statement"
              content={project.problem_statement}
              isHTML
            />
            <TextContainer
              label="Proposed (Idea) Solution"
              content={project.proposed_solution}
              isHTML
            />
            {/* The Documents */}
            <LinkTextContainer
              document={project.supporting_docs}
              role="Applicant"
              title="Supporting Documents"
            />
            <LinkTextContainer
              document={project.community_council_minute}
              role="Community"
              title="Community Council Minutes"
            />
            <LinkTextContainer
              document={project.provincial_council_minute}
              role="Province"
              title="Provincial Council Minutes"
            />
            <LinkTextContainer
              document={project.pdo_confirmation}
              role="PDO"
              title="PDO Confirmation"
            />

            {/* Buttons for Actions */}
            <div className="flex justify-between items-center pt-4 pb-10">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/projects/proposals");
                }}
                className="cancel-rss-btn"
                disabled={projectBkg}
              >
                Back
              </button>
              <button
                type="submit"
                disabled={projectBkg}
                className="add-rss-btn"
              >
                Continue
              </button>
            </div>
          </div>
        </form>
      )}
    </MainContainer>
  );
};

export default PhaseTwoBegin;
